import React from 'react'
import tw from 'twin.macro'
import styled from 'styled-components'
import { SectionHeading as HeadingTitle } from '../misc/Headings.js'
import { ReactComponent as SvgDecoratorBlob1 } from '../../images/svg-decorator-blob-1.svg'
import { ReactComponent as SvgDecoratorBlob2 } from '../../images/svg-decorator-blob-3.svg'
import { SectionDescription } from "components/misc/Typography.js";
import rideShare from "../../images/ride_share.jpg";
import ttc from "../../images/TTC.jpg";
import car from "../../images/car.png";

const Container = tw.div`relative`
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`
const ThreeColumn = tw.div`flex flex-col items-center lg:items-stretch lg:flex-row flex-wrap`
const Column = tw.div`mt-24 lg:w-1/3`

const HeadingInfoContainer = tw.div`flex flex-col items-center`
const HeadingDescription = tw.p`mt-4 font-medium text-gray-600 text-center max-w-sm`

const Card = tw.div`lg:mx-4 xl:mx-8 max-w-sm lg:max-w-xs`
const Image = styled.div((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`bg-cover bg-center h-80 lg:h-64 rounded`,
])
const Category = tw.div`mt-4 text-secondary-100 font-bold text-sm`
const Title = tw.h4`mt-2 leading-relaxed font-bold text-lg text-center`
const Link = tw.a`inline-block mt-2 text-sm text-primary-500 font-bold cursor-pointer transition duration-300 border-b-2 border-transparent hover:border-primary-500`
const Description = tw(SectionDescription)`w-full text-center`;

const DecoratorBlob1 = tw(
  SvgDecoratorBlob1
)`-z-10 absolute bottom-0 right-0 w-48 h-48 transform translate-x-40 -translate-y-8 opacity-25`
const DecoratorBlob2 = tw(
  SvgDecoratorBlob2
)`-z-10 absolute top-0 left-0 w-48 h-48 transform -translate-x-32 translate-y-full opacity-25`

export default () => {
  const blogPosts = [
    {
      imageSrc: rideShare,
      title: 'By Ride Share',
      text: 'Have yourself dropped off at 145 Queens Quay West. We’re located right behind the Second Cup / Beaver Tails. Look for our yellow and black water taxis.',
    },
    {
      imageSrc: ttc,
      title: 'By Public Transit',
      text: 'From Union Station take the TTC streetcar 509 or 510. Disembark at Harbourfront Centre, your first above ground stop. Walk East towards York Street.',
    },
    {
      imageSrc: car,
      title: 'By Car',
      text: 'Public Parking is available along Queen’s Quay West and on the west side of the Queen’s Quay Terminal. (207 Queen’s Quay West at the foot of York Street)',
    },
  ]
  return (
    <Container>
      <Content>
        <HeadingInfoContainer>
          <HeadingTitle>How to Reach Our York St Location:</HeadingTitle>
        </HeadingInfoContainer>
        <ThreeColumn>
          {blogPosts.map((post, index) => (
            <Column key={index}>
              <Card>
                <Image imageSrc={post.imageSrc} />
                <Title>{post.title}</Title>
                <Description>{post.text}</Description>
              </Card>
            </Column>
          ))}
        </ThreeColumn>
      </Content>
      <DecoratorBlob1 />
      <DecoratorBlob2 />
    </Container>
  )
}
